import React from 'react';

const SvgCircuits: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42" {...props}>
      <defs>
        <clipPath id="circuits_svg__a">
          <path d="M0 0h42v42H0z" />
        </clipPath>
      </defs>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9h18" />
      <g
        clipPath="url(#circuits_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect width={7} height={10} rx={1} transform="translate(30 28)" />
        <path d="M12 33h18" />
        <rect width={7} height={10} rx={1} transform="translate(5 28)" />
        <rect width={7} height={11} rx={1} transform="translate(30 3)" />
        <rect width={7} height={11} rx={1} transform="translate(5 3)" />
        <path d="M21.525 26.25L24.15 21h-6.3l2.625-5.25" />
      </g>
    </svg>
  );
};

export default SvgCircuits;
